import { ENTITIES_LIST_CLASS_NAME } from '../../constants/mui-components';

const MuiList = {
  styleOverrides: {
    root: ({ gap }) => ({
      [`&.${ENTITIES_LIST_CLASS_NAME}`]: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: gap || '10rem',
        alignSelf: 'stretch',
        flex: '1 0 0',
      },
    }),
  },
};

export default MuiList;
